<template>
  <div
    v-bind:id="p_customId"
    class="configurator-step-wrapper"
    v-bind:class="{ 'input-step': inputStepFields.length > 0, p_customClass }"
    v-show="p_isVisible"
    v-observe-visibility="checkInputStepVisibility"
  >
    <div class="configurator-step-headline-wrapper" v-if="special == null">
      <h2 class="configurator-step-headline">{{ p_headline }}</h2>
      <div v-if="p_subHeadline" class="configurator-step-subheadline-wrapper">
        <!-- p_subHeadlineType in class und Icon übergeben -->
        <h3
          v-if="p_subHeadlineType == 'information'"
          class="information-headline configurator-step-subheadline"
        >
          <i class="configurator-step-subheadline-icon fal fa-info-circle"></i>
          {{ p_subHeadline }}
        </h3>
        <h3
          v-else-if="p_subHeadlineType == 'warning'"
          class="warning-headline configurator-step-subheadline"
        >
          <i
            class="configurator-step-subheadline-icon fal fa-exclamation-triangle"
          ></i>
          {{ p_subHeadline }}
        </h3>
        <h3
          v-else-if="p_subHeadlineType == 'price'"
          class="price-headline configurator-step-subheadline"
        >
          <i class="configurator-step-subheadline-icon fal fa-euro-sign"></i>
          {{ p_subHeadline }}
        </h3>
        <h3 v-else class="configurator-step-subheadline">
          {{ p_subHeadline }}
        </h3>
      </div>
      <div class="mobile-configurator-step-subheadline-wrapper"></div>
    </div>
    <div
      v-bind:style="{
        display:
          p_customId == 'quadrat_duschwanne_maße' ||
          p_customId == 'rechteck_duschwanne_maße' ||
          p_customId == 'quadrat_duschwanne_sichtkanten_' ||
          p_customId == 'rechteck_duschwanne_sichtkanten_' ||
          p_customId == 'viertelkreis_duschwanne_maße' ||
          p_customId == 'fünfeck_duschwanne_maße'
            ? 'flex'
            : 'none'
      }"
      class="configurator-selected-image"
    >
      <img
        v-if="!isNischendusche"
        v-bind:style="{
          display: p_customId == 'quadrat_duschwanne_maße' ? 'flex' : 'none'
        }"
        src="../../assets/images/Group 281.svg"
      />

      <img
        v-if="isNischendusche"
        v-bind:style="{
          display: p_customId == 'quadrat_duschwanne_maße' ? 'flex' : 'none'
        }"
        src="../../assets/images/Group 280.svg"
      />

      <img
        v-if="!isNischendusche"
        v-bind:style="{
          display: p_customId == 'rechteck_duschwanne_maße' ? 'flex' : 'none'
        }"
        src="../../assets/images/Group 243.svg"
      />

      <img
        v-if="isNischendusche"
        v-bind:style="{
          display: p_customId == 'rechteck_duschwanne_maße' ? 'flex' : 'none'
        }"
        src="../../assets/images/Group 242.svg"
      />

      <img
        v-if="!isNischendusche"
        v-bind:style="{
          display:
            p_customId == 'quadrat_duschwanne_sichtkanten_' ? 'flex' : 'none'
        }"
        src="../../assets/images/Group 281.svg"
      />

      <img
        v-if="isNischendusche"
        v-bind:style="{
          display:
            p_customId == 'quadrat_duschwanne_sichtkanten_' ? 'flex' : 'none'
        }"
        src="../../assets/images/Group 280.svg"
      />

      <img
        v-if="!isNischendusche"
        v-bind:style="{
          display:
            p_customId == 'rechteck_duschwanne_sichtkanten_' ? 'flex' : 'none'
        }"
        src="../../assets/images/Group 243.svg"
      />

      <img
        v-if="isNischendusche"
        v-bind:style="{
          display:
            p_customId == 'rechteck_duschwanne_sichtkanten_' ? 'flex' : 'none'
        }"
        src="../../assets/images/Group 242.svg"
      />

      <img
        v-bind:style="{
          display:
            p_customId == 'viertelkreis_duschwanne_maße' ? 'flex' : 'none'
        }"
        src="../../assets/images/Group 244.svg"
      />

      <img
        v-bind:style="{
          display: p_customId == 'fünfeck_duschwanne_maße' ? 'flex' : 'none'
        }"
        src="../../assets/images/Group 245.svg"
      />
    </div>
    <div
      v-bind:style="{
        display:
          p_customId == 'quadrat_duschwanne_maße' ||
          p_customId == 'eckdusche_rückwand_maße' ||
          p_customId == 'walk_in_dusche_rückwand_maße' ||
          p_customId == 'nischendusche_rückwand_maße'
            ? 'flex'
            : 'none'
      }"
      class="configurator-selected-image ruckwand-selected-image"
    >
      <div
        v-if="p_customId == 'eckdusche_rückwand_maße'"
        v-bind:style="{
          display: p_customId == 'eckdusche_rückwand_maße' ? 'flex' : 'none'
        }"
      >
        <img
          v-bind:id="p_customId + '_left'"
          v-bind:style="{
            display: p_customId == 'eckdusche_rückwand_maße' ? 'flex' : 'none'
          }"
          src="../../assets/images/Rückwände_Eckdusche_left.svg"
        />
        <img
          v-bind:id="p_customId + '_right'"
          style="display:none"
          src="../../assets/images/Rückwände_Eckdusche_right.svg"
        />
      </div>
      <div
        v-else-if="p_customId == 'walk_in_dusche_rückwand_maße'"
        v-bind:style="{
          display:
            p_customId == 'walk_in_dusche_rückwand_maße' ? 'flex' : 'none'
        }"
      >
        <img
          v-bind:id="p_customId + '_left'"
          v-bind:style="{
            display:
              p_customId == 'walk_in_dusche_rückwand_maße' ? 'flex' : 'none'
          }"
          src="../../assets/images/Rückwände_walkin_left.svg"
        />
        <img
          v-bind:id="p_customId + '_right'"
          style="display:none"
          src="../../assets/images/Rückwände_walkin_right.svg"
        />
      </div>
      <div
        v-else-if="p_customId == 'nischendusche_rückwand_maße'"
        v-bind:style="{
          display: p_customId == 'nischendusche_rückwand_maße' ? 'flex' : 'none'
        }"
      >
        <img
          v-bind:id="p_customId + '_left'"
          v-bind:style="{
            display:
              p_customId == 'nischendusche_rückwand_maße' ? 'flex' : 'none'
          }"
          src="../../assets/images/Nischendusche_left.svg"
        />
        <img
          v-bind:id="p_customId + '_middle'"
          style="display:none"
          src="../../assets/images/Nischendusche_behind.svg"
        />
        <img
          v-bind:id="p_customId + '_right'"
          style="display:none"
          src="../../assets/images/Nischendusche_right.svg"
        />
      </div>
    </div>
    <div
      class="configurator-step-form-wrapper"
      v-bind:class="{ special: special != null }"
    >
      <selection-card
        v-for="(selectionCard, index) in selectionCards"
        v-bind:key="index"
        v-bind:p_index="index"
        ref="selectionCardListItems"
        v-bind:p_selectionCard="selectionCard"
        v-bind:p_allowLightbox="true"
      />

      <template v-if="special !== null">
        <component v-bind:is="specialComponent"> </component>
      </template>

      <template v-if="inputStepFields.length > 0">
        <div
          v-observe-visibility="calculateMissingFieldFirstTime"
          class="calculation-input"
        >
          <label for="calculation">Automatische Berechnung</label>
          <input
            ref="calcInput"
            type="number"
            disabled="disabled"
            name="calculation"
          />
          <span class="input-field-calc-unit">mm</span>
        </div>
        <div
          v-bind:class="inputStepField.name"
          v-bind:key="index"
          v-for="(inputStepField, index) in inputStepFields"
        >
          <div class="input-fields-outside-wrapper">
            <label v-bind:for="inputStepField.name">{{
              inputStepField.label
            }}</label>
            <input
              ref="inputFields"
              @focusin="$event.target.select()"
              @focus="toggleVisibility(inputStepField.name, p_customId)"
              v-if="inputStepField.type == 'integer'"
              v-on:input="executeInput(inputStepField)"
              type="number"
              v-bind:name="inputStepField.name"
              v-bind:min="inputStepField.minValue"
              v-bind:max="inputStepField.maxValue"
              v-model="inputStepField.value"
              data-placeholder="mm"
              v-bind:class="
                inputStepField.value.length == 0 ||
                parseInt(inputStepField.value) < inputStepField.minValue ||
                parseInt(inputStepField.value) > inputStepField.maxValue
                  ? 'input-field-incorrect'
                  : 'input-field-correct'
              "
              v-bind:disabled="isInputFieldDisabled(p_stepId, index)"
            />
            <span class="input-field-unit">mm</span>
          </div>
          <div class="warning-fields-outisde-wrapper">
            <div
              class="input-field-infobox"
              v-bind:class="
                inputStepField.value.length == 0 ||
                parseInt(inputStepField.value) < inputStepField.minValue ||
                parseInt(inputStepField.value) > inputStepField.maxValue
                  ? ''
                  : 'input-field-infobox-hidden'
              "
            >
              Der eingegebene Wert muss zwischen
              {{ inputStepField.minValue }} und
              {{ inputStepField.maxValue }} liegen.
            </div>
            <div class="input-checkbox-row">
              <input
                ref="checkBoxFields"
                type="checkbox"
                v-model="inputStepField.isVisibleEdge"
                v-bind:id="inputStepField.name + '-' + index"
                @change="checkBoxStateChanged()"
              />
              <label v-bind:for="inputStepField.name + '-' + index"
                >Diese Seite zeigt in den Raum</label
              >
            </div>
          </div>
        </div>
        <div class="save-choice">
          <div v-if="isCustomButtonVisible" class="customButtonWrapper">
            <div class="customButtonHtml" v-html="customButtonHtml"></div>
            <button
              class="configurator-button button brand-color customStepButton"
              @click="executeCustomButton()"
            >
              <span class="configurator-button-label">{{
                customButtonLabel
              }}</span>
            </button>
          </div>
          <Button
            p_label="Auswahl speichern"
            p_customClass="configurator-card-element-button brand-color"
            v-bind:p_disabled="isSaveButtonDisabled"
          />
        </div>
      </template>
    </div>
    <component ref="mainComponent" v-bind:is="mainComponent"></component>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import SelectionCard from "./SelectionCard";
import Button from "./Button";

const urlGetInputPerStepRest =
  process.env.URL_BACKEND +
  process.env.REST_INPUT_STEP_FIELD_READ_ALL_INPUT_STEP_FIELD_STEPS_BY_STEP;
const urlGetAllSelectionCardsPerStepRest =
  process.env.URL_BACKEND +
  process.env.REST_SELECTION_CARD_GET_ALL_SELECTION_CARDS_PER_STEP;
const urlGetSpecialPerStepRest =
  process.env.URL_BACKEND + process.env.REST_SPECIAL_GET_SPECIAL_PER_STEP;
const urlDetermineArticlePriceRest =
  process.env.URL_BACKEND + process.env.REST_ARTICLE_PRICE_DETERMINE_PRICE;
const urlFindProductRest =
  process.env.URL_BACKEND + process.env.REST_PRODUCT_FIND_PRODUCT;

export default {
  components: { Button, SelectionCard },
  props: {
    p_index: Number,
    p_stepId: Number,
    p_headline: String,
    p_customId: String,
    p_stepType: String,
    p_configuratorDomain: String,
    p_isSkippable: Boolean,
    p_skippableAttributeId: Number,
    p_skippableAttributeName: String,
    p_customClass: {
      default: null,
      type: String
    },
    p_isVisible: {
      default: true,
      type: Boolean
    },
    p_subHeadline: {
      default: null,
      type: String
    },
    p_subHeadlineType: {
      default: null,
      type: String
    }
  },
  data() {
    return {
      checkBoxesSelected: [],
      selectionCards: [],
      selectionCardsReady: [],
      inputStepFields: [],
      special: null,
      specialComponent: null,
      mainComponent: null,
      customButtonHtml: "",
      customButtonLabel: "",
      allSelectionCardsReady: false,
      // TODO: Replace later
      isNischendusche: false,
      isInputStep: false,
      isSaveButtonDisabled: false,
      isVisibleFirstTime: true,
      isCustomButtonVisible: false
    };
  },
  methods: {
    executeCustomButton() {
      this.$refs.mainComponent.executeStepCustomButton(this);
    },
    toggleVisibility(varTest, elID) {
      let leftImage = document.getElementById(elID + "_left");
      let rightImage = document.getElementById(elID + "_right");
      let middleImage = document.getElementById(elID + "_middle");
      if (varTest == "höhe-rückwand-1" || varTest == "breite-rückwand-1") {
        leftImage.style.display = "flex";
        rightImage.style.display = "none";
        if (elID == "nischendusche_rückwand_maße") {
          middleImage.style.display = "none";
        }
      } else if (
        varTest == "höhe-rückwand-2" ||
        varTest == "breite-rückwand-2"
      ) {
        leftImage.style.display = "none";
        rightImage.style.display = "flex";
        if (elID == "nischendusche_rückwand_maße") {
          middleImage.style.display = "none";
        }
      } else if (
        varTest == "höhe-rückwand-3" ||
        varTest == "breite-rückwand-3"
      ) {
        leftImage.style.display = "none";
        rightImage.style.display = "none";
        middleImage.style.display = "flex";
      }
    },
    isInputFieldDisabled(stepId, inputFieldIndex) {
      if (this.$refs.mainComponent != undefined) {
        return this.$refs.mainComponent.isInputFieldDisabled(
          stepId,
          inputFieldIndex
        );
      }
      return false;
    },
    executeInput(inputStepFieldRef) {
      this.$refs.mainComponent.executeCustomVueStepInputCode(this);
      let allInputFieldsHaveValues = true;
      if (this.$refs.inputFields != undefined) {
        this.inputStepFields.forEach(inputField => {
          if (
            inputField.minValue > 0 &&
            (inputField.value.length == 0 ||
              parseInt(inputField.value) < inputField.minValue ||
              parseInt(inputField.value) > inputField.maxValue)
          ) {
            allInputFieldsHaveValues = false;
            this.isSaveButtonDisabled = true;
          }
        });
      }
      if (allInputFieldsHaveValues) {
        this.$refs.mainComponent.executeInput(this.$refs.inputFields);
        this.isSaveButtonDisabled = false;
      }
      // Check State of the Save Button
      switch (this.p_stepId) {
        case 13:
        case 14:
        case 27:
        case 28:
        case 29:
          let oneCheckBoxClicked = false;
          let numberOfBoxesClicked = 0;
          this.inputStepFields.forEach(inputStepField => {
            if (!oneCheckBoxClicked) {
              oneCheckBoxClicked = inputStepField.isVisibleEdge;
            }
            if (inputStepField.isVisibleEdge) {
              numberOfBoxesClicked++;
            }
          });
          if (!oneCheckBoxClicked) {
            this.isSaveButtonDisabled = true;
          }
          //For nischendusche only exactly one side should be checked
          if (this.$store.getters.isValueFound("nischendusche")) {
            this.isSaveButtonDisabled = numberOfBoxesClicked != 1;
          }
          break;
        case 15:
          break;
      }
    },
    checkBoxStateChanged() {
      this.executeInput(this.$refs.inputFields[0]);
    },
    calculateMissingFieldFirstTime(isVisible) {
      if (isVisible) {
        if (this.isVisibleFirstTime) {
          this.$refs.mainComponent.executeInput(this.$refs.inputFields);
        }
        this.isVisibleFirstTime = false;
      }
    },
    checkInputStepVisibility(isVisible) {
      if (isVisible) {
        this.$refs.mainComponent.customInputRestrictions(this);
        // InputField Default Values (Like Standardmass preselected values from other step)
        if (this.$refs.mainComponent != undefined) {
          // Check if the customStepButton is active
          this.$refs.mainComponent.executeCustomVueStepInputCode(this);
          for (let i = 0; i < this.inputStepFields.length; ++i) {
            let defaultValue = this.$refs.mainComponent.getDefaultInputFieldValues(
              this.p_stepId,
              i
            );
            if (defaultValue > 0) {
              this.inputStepFields[
                i
              ].value = this.$refs.mainComponent.getDefaultInputFieldValues(
                this.p_stepId,
                i
              );
            }
          }
        }

        // Check State of the Save Button
        switch (this.p_stepId) {
          case 13:
          case 14:
          case 27:
          case 28:
          case 29:
            let oneCheckBoxClicked = false;
            let numberOfBoxesClicked = 0;
            this.inputStepFields.forEach(inputStepField => {
              if (!oneCheckBoxClicked) {
                oneCheckBoxClicked = inputStepField.isVisibleEdge;
              }
              if (inputStepField.isVisibleEdge) {
                numberOfBoxesClicked++;
              }
            });
            if (!oneCheckBoxClicked) {
              this.isSaveButtonDisabled = true;
            }
            //For nischendusche only exactly one side should be checked
            if (this.$store.getters.isValueFound("nischendusche")) {
              this.isSaveButtonDisabled = numberOfBoxesClicked != 1;
            }
            break;
          case 15:
            break;
        }
      }
    },
    executeButton() {
      if (this.isInputStep) {
        this.executeInputStepButton();
      }
      this.goToNextStep();
    },
    executeInputStepButton() {
      this.saveStepValue(null);
    },
    writeIntoCalcInput(value) {
      this.$refs.calcInput.value = value;
    },
    renderSpecialComponent(special) {
      this.specialComponent = () =>
        import(
          `../customer/${this.p_configuratorDomain}/${special.vueComponent}`
        );
      this.$parent.setStepReady(this.p_index);
    },
    getAllSelectionCardsPerStep() {
      // Call REST getspecialperstep
      const json = JSON.stringify({ step: { id: this.p_stepId } });
      axios
        .post(urlGetAllSelectionCardsPerStepRest, json, {
          headers: {
            // Overwrite Axios's automatically set Content-Type
            "Content-Type": "application/json"
          }
        })
        .then(result => {
          result.data.forEach(element => {
            let tmpMedia = element.media_ids;
            let selectionCardAlreadyPushed = false;
            // Search if the Selection card is pushed
            // if it is already pushed add the value
            this.selectionCards.forEach(selectionCardElement => {
              if (selectionCardElement.id == element.selection_card_id) {
                selectionCardElement.values.push({
                  selectionCardId: element.id,
                  attributeId: element.attribute_id,
                  attributeName: element.attribute_name,
                  attributeVisible: element.attribute_visible,
                  name: element.name,
                  value: element.value,
                  valueName: element.value_name
                });
                selectionCardAlreadyPushed = true;
                return;
              }
            });
            if (!selectionCardAlreadyPushed) {
              let tmpValues = [];
              tmpValues.push({
                selectionCardId: element.id,
                attributeId: element.attribute_id,
                attributeName: element.attribute_name,
                attributeVisible: element.attribute_visible,
                name: element.name,
                value: element.value,
                valueName: element.value_name
              });
              this.selectionCards.push({
                id: element.selection_card_id,
                name: element.name,
                description: element.description,
                buttonText: element.button_text,
                articleIds: element.article_ids,
                articleQuantities: element.quantities,
                dropdownElementIds: element.dropdown_element_ids,
                visibleRuleId: element.visibility_rule_id,
                disableRuleId: element.disable_rule_id,
                disableText: element.disable_text,
                preferenceRuleId: element.preference_rule_id,
                preferenceText: element.preference_text,
                values: tmpValues,
                media: tmpMedia,
                iconTick: ""
              });
            }
          });
        })
        .finally(() => {
          this.$parent.setSelectionCardAxiosReady(true);
          this.selectionCards.forEach(selectionCard => {
            // Get the dropdown element if set
            this.selectionCardsReady.push(false);
          });
          this.getSelectionCardsDropdownElement();
          this.checkRules();
        });
    },
    setDropdown(selectionCardId, dropdownId) {
      let selectionCardIndex = -1;
      let tmpIndex = 0;
      this.selectionCards.forEach(element => {
        if (element.id == selectionCardId) {
          selectionCardIndex = tmpIndex;
        }
        tmpIndex = tmpIndex + 1;
      });
      if (
        this.$refs.selectionCardListItems[selectionCardIndex] != null &&
        this.$refs.selectionCardListItems[selectionCardIndex].setDropdown !=
          "undefined"
      ) {
        this.$refs.selectionCardListItems[selectionCardIndex].setDropdown(
          dropdownId
        );
      }
    },
    getSpecialPerStep() {
      // Call REST validaterule
      const json = JSON.stringify({ step: { id: this.p_stepId } });
      axios
        .post(urlGetSpecialPerStepRest, json, {
          headers: {
            // Overwrite Axios's automatically set Content-Type
            "Content-Type": "application/json"
          }
        })
        .then(result => {
          this.special = {
            id: result.data.id,
            name: result.data.name,
            description: result.data.description,
            vueComponent: result.data.vue_component
          };
          if (this.special != null && this.special.vueComponent != null)
            this.renderSpecialComponent(this.special);
          else this.special = null;
          this.$parent.setStepReady(this.p_index);
        });
    },
    getInputStepPerStep() {
      // Call REST validaterule
      const json = JSON.stringify({ step: { id: this.p_stepId } });
      axios
        .post(urlGetInputPerStepRest, json, {
          headers: {
            // Overwrite Axios's automatically set Content-Type
            "Content-Type": "application/json"
          }
        })
        .then(result => {
          let isInputStep = false;
          result.data.forEach(element => {
            let inputStepField = {
              maxAttribute: element.max_attribute_id,
              minAttribute: element.min_attribute_id,
              name: element.name.replace(/ /g, "-").toLowerCase(),
              label: element.label,
              type: element.type,
              visibilityRule: element.visibility_rule,
              minValue: -1,
              maxValue: -1,
              value: 0,
              isVisibleEdge: false
            };
            this.inputStepFields.push(inputStepField);
            isInputStep = true;
          });
          if (isInputStep) {
            this.$parent.setStepReady(this.p_index);
          }
          this.isInputStep = isInputStep;
        })
        .finally(() => {
          this.mainComponent = () =>
            import(`../customer/${this.p_configuratorDomain}/Main.vue`);
        });
    },
    setInputs() {
      // Sets the input after loading a saved configuration
      let i = 0;
      this.inputStepFields.forEach(inputStepField => {
        this.$store.state.stepValues.forEach(stepValue => {
          if (stepValue.stepId == this.p_stepId) {
            if (stepValue.minAttribute == inputStepField.minAttribute) {
              inputStepField.minValue = parseInt(stepValue.minValue);
            }
            if (stepValue.maxAttribute == inputStepField.maxAttribute) {
              inputStepField.maxValue = parseInt(stepValue.maxValue);
            }
            if (
              stepValue.stepName != null &&
              stepValue.stepName.includes("sichtkante") &&
              stepValue.value + "" == inputStepField.value + ""
            ) {
              inputStepField.isVisibleEdge = stepValue.isVisibleEdge;
            }
            if (stepValue.inputStepIndex == i) {
              inputStepField.value = parseInt(stepValue.value);
              if (stepValue.isVisibleEdge != undefined) {
                inputStepField.isVisibleEdge = stepValue.isVisibleEdge;
              }
            }
          }
        });
        ++i;
      });
    },
    initializeStep() {
      // Get minValue and maxValue
      this.inputStepFields.forEach(inputStepField => {
        if (inputStepField.minValue < 0) {
          this.$store.state.stepValues.forEach(stepValue => {
            if (stepValue.attributeId == inputStepField.minAttribute) {
              inputStepField.minValue = parseInt(stepValue.value);
              inputStepField.value = inputStepField.minValue;
            }
            if (stepValue.attributeId == inputStepField.maxAttribute) {
              inputStepField.maxValue = parseInt(stepValue.value);
            }
          });
        }
      });
    },
    goToNextStep() {
      this.$parent.checkIfStepIsHidden();
      this.$parent.checkPrice();
      this.$parent.checkRuleCompletedBeforeNextStep();
    },
    resetTicks() {
      // reset all tick icons
      this.selectionCards.forEach(element => {
        element.iconTick = "";
      });
    },
    setSelectionCardReady(index) {
      // The selection card calls this method
      // when all images are loaded
      this.selectionCardsReady[index] = true;
      let allSelectionCardsReady = true;
      this.selectionCardsReady.forEach(element => {
        if (!element) {
          allSelectionCardsReady = false;
        }
      });
      this.allSelectionCardsReady = allSelectionCardsReady;
      if (this.allSelectionCardsReady) {
        this.$parent.setStepReady(this.p_index);
      }
    },
    setTick(selectionCardId) {
      // set tick where the id is like element.id
      this.selectionCards.forEach(element => {
        if (element.id == selectionCardId) element.iconTick = "fal fa-check";
      });
    },
    deleteStepValue() {
      this.$store.commit("deleteSpecificStep", this.p_stepId);
      this.refreshProducts();
    },
    async refreshProducts() {
      this.$store.commit("refreshProducts");

      let priceCheck = await this.checkProductPrices();

      if (priceCheck == 0) {
        this.$parent.setProductPricesSum(0);
      } else {
        this.$parent.singlePrices = priceCheck.data.single_prices;
        this.$parent.singleQuantityPrices =
          priceCheck.data.single_quantity_prices;
        this.$parent.setProductPricesSum(priceCheck.data.determined_price_sum);
      }
    },
    async saveStepValue(values) {
      // First delete all old saved step values
      this.deleteStepValue();
      if (values != null) {
        let index = 0;
        values.forEach(element => {
          let type = "normal";
          let dropdownId = -1;
          if (element.type != null) {
            type = element.type;
            dropdownId = element.dropdownId;
          }
          // Get Articles from value DropdownId
          let articleIds = [];
          let quantities = [];
          if (dropdownId >= 0) {
            let valueArray = element.value.split(";");
            if (valueArray.length >= 1) {
              valueArray.forEach(value => {
                if (value.includes("p:")) {
                  let articleIdString = value.split(":")[1];
                  articleIdString.split(",").forEach(articleId => {
                    if (articleId.includes("special")) {
                      articleId =
                        "" +
                        this.$refs.mainComponent.calculateCustomArticle(
                          articleId,
                          this.$store.state.stepValues
                        );
                    }
                    if (articleId != "") {
                      articleIds.push(articleId);
                    }
                  });
                } else if (value.includes("q:")) {
                  let quantityString = value.split(":")[1];
                  quantityString.split(",").forEach(quantity => {
                    if (isNaN(quantity)) {
                      quantity =
                        "" +
                        this.$refs.mainComponent.calculateQuantity(
                          quantity,
                          this.$store.state.stepValues
                        );
                      if (quantity != "") {
                        quantities.push(quantity);
                      }
                    } else {
                      quantities.push(quantity);
                    }
                  });
                }
              });
            }
          }
          let storeInput = {
            stepName: this.p_customId,
            stepId: this.p_stepId,
            selectionCardId: element.selectionCardId,
            attributeId: element.attributeId,
            attributeName: element.attributeName,
            attributeVisible: element.attributeVisible,
            name: element.name,
            valueName: element.valueName,
            value: element.value,
            dropdownId: dropdownId,
            type: type
          };
          // Reset attributeId
          // this is needable for the rules
          // if this is not done, the wrong value is tested
          // by the rules
          if (dropdownId >= 0) {
            storeInput.attributeId = -1;
          }
          // Dropdown Fields Custom
          if (articleIds.length > 0) {
            storeInput.articleIds = "";
            storeInput.articleQuantities = "";
            for (let i = 0; i < articleIds.length; ++i) {
              storeInput.articleIds += articleIds[i] + ";";
              storeInput.articleQuantities += quantities[i] + ";";
            }
            storeInput.articleIds = storeInput.articleIds.substring(
              0,
              storeInput.articleIds.length - 1
            );
            storeInput.articleQuantities = storeInput.articleQuantities.substring(
              0,
              storeInput.articleQuantities.length - 1
            );
          }
          //Article IDs need to be in first values entry
          if (index < 1) {
            storeInput.articleIds = element.articleIds;
            storeInput.articleQuantities = element.articleQuantities;
          }
          this.$store.commit("addStepValue", storeInput);
          ++index;
        });
      } else {
        if (this.isInputStep) {
          // TODO: Work out dynamic specific Step, quick fix for Duschking
          // this.$store.commit("deleteSpecificStep", 21);
          let concatValues = "";
          for (let i = 0; i < this.$refs.inputFields.length; ++i) {
            let inputField = this.$refs.inputFields[i];
            this.$store.commit("addStepValue", {
              stepName: this.p_customId,
              stepId: this.p_stepId,
              selectionCardId: -1,
              attributeId: -1,
              attributeName: "",
              inputStepIndex: i,
              minAttribute: this.inputStepFields[i].minAttribute,
              maxAttribute: this.inputStepFields[i].maxAttribute,
              minValue: this.inputStepFields[i].minValue,
              maxValue: this.inputStepFields[i].maxValue,
              attributeVisible: 0,
              valueName: inputField.name + ": " + inputField.value + "mm",
              value: inputField.value,
              isVisibleEdge: this.inputStepFields[i].isVisibleEdge
            });
            concatValues += inputField.value + "mm;";
          }
          concatValues = concatValues.substring(0, concatValues.length - 1);
          let concatValueNameSplitted = concatValues.split(";");
          let concatHeadLine = "";
          let concatValueName = "";
          for (let i = 0; i < concatValueNameSplitted.length; i = i + 2) {
            concatHeadLine = this.$refs.mainComponent.getCustomConcatHeadline(
              this.p_stepId,
              i
            );
            concatValueName +=
              concatHeadLine +
              "" +
              concatValueNameSplitted[i] +
              " x " +
              concatValueNameSplitted[i + 1] +
              ", ";
          }
          concatValueName =
            concatValues.length > 0
              ? concatValueName.substring(0, concatValueName.length - 2)
              : "";

          this.$store.commit("addStepValue", {
            stepName: this.p_customId,
            stepId: this.p_stepId,
            selectionCardId: -1,
            attributeId: -1,
            attributeName: "concat_val",
            inputStepIndex: -1,
            attributeVisible: 1,
            valueName: concatValueName,
            value: concatValues
          });
        }
      }
      // disable skip step
      if (this.p_skippableAttributeId != null) {
        this.$store.commit("addStepValue", {
          stepId: this.p_stepId,
          attributeId: this.p_skippableAttributeId,
          attributeName: this.p_skippableAttributeName,
          attributeVisible: 0,
          value: 0
        });
      }
      let returnValues = await this.$refs.mainComponent.checkCustomProducts(
        this.$store.state.stepValues,
        this.$store.getters.isValueFound("rock_2")
      );
      if (returnValues != undefined && returnValues.length > 0) {
        returnValues.forEach(async returnValue => {
          const json = JSON.stringify(returnValue);
          await axios
            .post(urlFindProductRest, json, {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json"
              }
            })
            .then(result => {
              this.$store.state.fallbackId = "";
              let specialProduct = {
                articleId: result.data.product_id + "",
                articleQuantity: returnValue.quantity
              };
              if (
                result.data.product_id ==
                returnValue.affectedProduct.fallback_product_id
              ) {
                this.$store.state.fallbackId = "" + result.data.product_id;
              }
              this.$store.commit("addSpecialProduct", specialProduct);
              this.refreshProducts();
            });
        });
      } else {
        this.refreshProducts();
      }
      // Check the visibility rules
      this.$parent.checkIfStepIsHidden();
      this.$parent.checkPrice();
    },
    setNextStepsToNotAccessible() {
      this.$parent.setNextStepsToNotAccessible();
    },
    getSelectionCardsDropdownElement() {
      if (this.$refs.selectionCardListItems != null) {
        this.$refs.selectionCardListItems.forEach(selectionCardItem => {
          selectionCardItem.getDropdownElement();
        });
      }
    },
    checkProductPrices() {
      // let determinedPriceGroup = "B2B / Händler netto";
      let determinedPriceGroup =
        document.getElementById("main") != null
          ? document.getElementById("main").getAttribute("data-customergroup")
          : "EK";
      // Determine the pricegroup only if no one from outside has been set

      for (let i = 0; i < this.$store.state.stepValues.length; ++i) {
        if (this.$store.state.stepValues[i].attributeId == -50) {
          determinedPriceGroup = this.$store.state.stepValues[i].value;
          break;
        }
      }
      if (this.$store.state.products.length > 0) {
        let productIdsString = "";
        let quantitiesString = "";
        this.$store.state.products.forEach(product => {
          productIdsString += product.articleId + ";";
          quantitiesString += product.articleQuantity + ";";
        });
        productIdsString = productIdsString.substring(
          0,
          productIdsString.length - 1
        );
        quantitiesString = quantitiesString.substring(
          0,
          quantitiesString.length - 1
        );
        let json = JSON.stringify({
          product_ids: productIdsString,
          quantities: quantitiesString,
          pricegroup: determinedPriceGroup
        });
        return axios.post(urlDetermineArticlePriceRest, json, {
          headers: {
            // Overwrite Axios's automatically set Content-Type
            "Content-Type": "application/json"
          }
        });
      } else {
        return 0;
      }
    },
    checkRules() {
      this.isNischendusche = this.$store.getters.isValueFound("nischendusche");
      let rulesForExecution = [];
      if (this.$refs.selectionCardListItems != null) {
        this.$refs.selectionCardListItems.forEach(selectionCardItem => {
          // It is needable to create a new variable, without
          // that a copy is used.
          let hasVisibleAxios = false;
          let ruleExecutionVariable = {
            executionAxios: null,
            selectionCardItem: null,
            variableString: ""
          };
          selectionCardItem["setVariable"]("isVisible", false);
          // First check if the selectioncard is visible
          let visibleAxios = selectionCardItem.getVisibleAxios();
          if (visibleAxios != null) {
            ruleExecutionVariable.executionAxios = visibleAxios;
            ruleExecutionVariable.selectionCardItem = selectionCardItem;
            ruleExecutionVariable.variableString = "isVisible";
            rulesForExecution.push(ruleExecutionVariable);
            hasVisibleAxios = true;
          }
          let disableAxios = selectionCardItem.getDisableAxios();
          if (disableAxios != null) {
            ruleExecutionVariable.executionAxios = disableAxios;
            ruleExecutionVariable.selectionCardItem = selectionCardItem;
            ruleExecutionVariable.variableString = "isDisabled";
            rulesForExecution.push(ruleExecutionVariable);
          } else {
            let preferenceAxios = selectionCardItem.getPreferenceAxios();
            if (preferenceAxios != null) {
              ruleExecutionVariable.executionAxios = preferenceAxios;
              ruleExecutionVariable.selectionCardItem = selectionCardItem;
              ruleExecutionVariable.variableString = "isPreferenced";
              rulesForExecution.push(ruleExecutionVariable);
            }
          }
          // If the ruleId is null but the disable text or preference text isn't
          // set the state to the selectionCard
          if (
            selectionCardItem.p_selectionCard.disable_rule_id == null &&
            selectionCardItem.p_selectionCard.disableText != null &&
            selectionCardItem.p_selectionCard.disableText.length > 0
          ) {
            selectionCardItem.isDisabled = true;
          } else if (
            selectionCardItem.p_selectionCard.preference_rule_id == null &&
            selectionCardItem.p_selectionCard.preferenceText != null &&
            selectionCardItem.p_selectionCard.preferenceText.length > 0
          ) {
            selectionCardItem.isPreferenced = true;
          }
          if (!hasVisibleAxios) {
            selectionCardItem["setVariable"]("isVisible", true);
          }
        });
      }
      let rulesAxios = [];
      rulesForExecution.forEach(ruleExecution => {
        rulesAxios.push(ruleExecution.executionAxios);
      });
      if (rulesAxios.length > 0) {
        axios.all(rulesAxios).then(
          axios.spread((...responses) => {
            for (let i = 0; i < rulesAxios.length; ++i) {
              rulesForExecution[i].selectionCardItem["setVariable"](
                rulesForExecution[i].variableString,
                responses[i].data
              );
            }
            this.$parent.setRuleCheckCompleted(true);
          })
        );
      } else {
        this.$parent.setRuleCheckCompleted(true);
      }
    },
    resetDropdowns() {
      if (this.$refs.selectionCardListItems != null) {
        this.$refs.selectionCardListItems.forEach(selectionCard => {
          if (selectionCard.p_selectionCard.dropdownElementIds != null) {
            selectionCard.resetDropdown();
          }
        });
      }
    },
    setLoadingPopupManually(isLoadingPopupVisible) {
      this.$parent.setLoadingPopupManually(isLoadingPopupVisible);
    },
    showInfoPopup() {
      this.$parent.showInfoPopup();
    },
    showShowerPopup() {
      this.$parent.showShowerPopup();
    },
    setPrice(price) {
      this.$parent.setPrice(price);
    }
  },
  beforeMount() {
    this.getAllSelectionCardsPerStep();
    this.getSpecialPerStep();
    this.getInputStepPerStep();
  },
  updated() {
    this.refreshProducts();
  }
};
</script>

<style language="css">
@import "../../scss/step/style.css";
</style>



// WEBPACK FOOTER //
// src/components/configurator/Step.vue